import DepsService from 'services/dependencies';
import flow from 'lodash/flow';
import orderBy from 'lodash/orderBy';
import uniqBy from 'lodash/uniqBy';
import get from 'lodash/get';
import filter from 'lodash/filter';

const CONTEXT = 'dashboard';

const extractJackpotsData = (draws) => {
  const flattenJackpotData = (draw) => ({
    gameNumber: get(draw, 'gameRuleSet.gameId') || '',
    name: get(draw, 'brandName') || get(draw, 'gameName') || '',
    amount: get(draw, 'jackpots[0].amount') || 0,
    drawDate: draw.drawTime,
    cashAmount: get(draw, 'jackpots[0].cashAmount') || 0,
    imageUrl: draw.imageUrl,
  });

  return flow([
    (items) => orderBy(items, ['drawTime', 'estimatedJackpot'], ['asc', 'desc']),
    (items) => items.map((item) => flattenJackpotData(item)),
    (items) => uniqBy(items, 'name'),
    (items) => filter(items, (item) => item.amount > 0),
  ])(draws);
};

export const fetchJackpotsAndDraws = async (widgetsDataJackpotsAndDraws) => {
  const { url } = DepsService.rest.widgets.jackpotsAndDraws;
  const queryParams = {
    status: 'OPEN',
    'game-names': widgetsDataJackpotsAndDraws,
  };
  const urlParams = {};

  const response = await DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
  return extractJackpotsData(get(response, 'draws'));
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/jackpots-next-draws.api.js